import { Component } from '@angular/core';

@Component({
    selector: 'ca-permission-denied',
    templateUrl: './permission-denied.component.html',
    styleUrls: ['./permission-denied.component.scss'],
})
export class PermissionDeniedComponent {}
